import React from 'react';
import './PriceLevelWidgets.css';

type PriceLevelWidgetProps = {
    price: React.ReactNode;
    quantity: React.ReactNode;
    amount?: React.ReactNode;
    className?: string;
    depthPct?: number;
};

const PriceLevelWidget = ({
    price,
    quantity,
    amount,
    className,
    depthPct,
}: PriceLevelWidgetProps) => {
    const style =
        depthPct != null
            ? ({ '--depth-pct': `${depthPct.toFixed(1)}%` } as React.CSSProperties)
            : undefined;

    return (
        <div className={`price-level-widget ${className || ''}`} style={style}>
            <span className="price">{price}</span>
            <span className="quantity">{quantity}</span>
            <span className="amount">{amount}</span>
        </div>
    );
};

export default PriceLevelWidget;
